/**
 * @enum FieldType
 */
enum FieldType {
  PLATFORM = "PLATFORM",
  USER_DEFINED = "USER_DEFINED",
  FIELD_GROUP = "FIELD_GROUP"
}

export default FieldType;
